import type { GaVueComponent } from "@/common/vueUtils";
import { GaChip } from "@/components/general/GaChip";
import { useGaContext } from "@utils/vue-migration/common/gaContext/gaContext";
import "./GaFeedback.scss";

export function MailFeedback(props: { mailTitle: string; mailBody: string }): GaVueComponent {
  const { t } = useGaContext();
  return (
    <a href={`mailto:feedback@getabstract.com?subject=${encodeURIComponent(props.mailTitle)}&body=${encodeURIComponent(props.mailBody)}`} target="_blank">
      <i class="ico-envelope"></i>
      {t("search:askGa.feedback.wantToGiveFeedback")}
    </a>
  );
}

export function GaFeedback(props: {
  title: string;
  positiveFeedbackText: string;
  negativeFeedbackText: string;
  showMailFeedbackLink?: boolean;
  changeHandler: (feedbackValue: boolean) => void;
  buttonBorder?: boolean;
  mailTitle: string;
  mailBody: string;
  value?: boolean;
}): GaVueComponent {
  return (
    <div class="d-grid gap-3">
      <h5 class="m-0">{props.title}</h5>
      <div class="getabstract__feedback">
        <GaChip icon="ico-thumbs-up" variant="success" border={props.buttonBorder} active={props.value === true} type="radio" name="ga-feedback" changeHandler={() => props.changeHandler(true)}>
          {props.positiveFeedbackText}
        </GaChip>
        <GaChip icon="ico-thumbs-down" variant="danger" border={props.buttonBorder} active={props.value === false} type="radio" name="ga-feedback" changeHandler={() => props.changeHandler(false)}>
          {props.negativeFeedbackText}
        </GaChip>
        {props.showMailFeedbackLink === true ? <MailFeedback mailTitle={props.mailTitle} mailBody={props.mailBody} /> : null}
      </div>
    </div>
  );
}
